import React, { JSX, MouseEventHandler } from 'react';
import { Login, useAuth } from '@ibe/components';
import { Modal, ModalBody, ModalHeader, ModalProps } from 'reactstrap';
import Keys from '@/Translations/generated/en/login-form.json.keys';
import LoginForm from '@/Layouts/Header/LoginForm';
import { useTranslation } from '@/app/i18n/client';

interface Props extends ModalProps {
  onSuccess?: () => void;
  onFailure?: () => void;
  onForgotPassword?: () => void;
}

const LoginModal = (props: Props): JSX.Element => {
  const { persistToken } = useAuth();
  const { t } = useTranslation('login-form');

  const onSuccess = async () => {
    persistToken();
    if (props.onSuccess) {
      props.onSuccess();
    }
  };

  const modalClasses = `login-modal ${props['className'] ? props['className'] : ''}`;

  return (
    <Modal
      isOpen={props.isOpen}
      className={modalClasses}
      modalClassName="login-modal-container"
      container={document.getElementById('iso') || undefined}
    >
      <ModalHeader toggle={props['toggle'] as MouseEventHandler}>{t(Keys.headline)}</ModalHeader>
      <ModalBody>
        <Login
          Form={LoginForm}
          onPasswordChangeRequired={() => {}}
          onSuccess={onSuccess}
          withCaptcha
          hasResetPassword
        />
      </ModalBody>
    </Modal>
  );
};

export default LoginModal;
